import { render, staticRenderFns } from "./DisSetting.vue?vue&type=template&id=41caab67&scoped=true&"
import script from "./DisSetting.vue?vue&type=script&lang=js&"
export * from "./DisSetting.vue?vue&type=script&lang=js&"
import style0 from "./DisSetting.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DisSetting.vue?vue&type=style&index=1&id=41caab67&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41caab67",
  null
  
)

export default component.exports